// extracted by mini-css-extract-plugin
export default {"goBack":"cart_goBack__eqYxm","goBackLda":"cart_goBackLda__00Up-","title":"cart_title__1q5Vl"};